import { Icon } from "@blueprintjs/core";

import { Button } from "@/components/ui/button";
import { EvaluationCriteria } from "@/types/roleplays";

import { useEvaluationCriteriaModalsContext } from "./EvaluationCriteriaModals";

interface EvaluationCriteriaToolbarProps {
  criteria: EvaluationCriteria[];
  className?: string;
}

export function EvaluationCriteriaToolbar({
  criteria,
  className,
}: EvaluationCriteriaToolbarProps) {
  const { handleSort, handleAdd, handleImport, handleRemoveAll } =
    useEvaluationCriteriaModalsContext();

  return (
    <div
      className={`border-border rounded-md border bg-white p-2 ${
        className || ""
      }`}
    >
      <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="minimal"
          intent="secondary"
          size="sm"
          className="font-normal text-gray-700"
          onClick={handleSort}
          disabled={criteria.length === 0}
        >
          <Icon icon="arrows-vertical" />
          Reorder
        </Button>

        <div className="h-7 border-l border-gray-300" />

        <Button
          variant="minimal"
          intent="secondary"
          size="sm"
          className="font-normal text-gray-700"
          onClick={handleAdd}
        >
          <Icon icon="plus" />
          Add Criteria
        </Button>

        <Button
          variant="minimal"
          intent="secondary"
          size="sm"
          className="font-normal text-gray-700"
          onClick={handleImport}
        >
          <Icon icon="duplicate" />
          Import
        </Button>

        <Button
          variant="minimal"
          intent="secondary"
          size="sm"
          className="font-normal text-gray-700"
          onClick={handleRemoveAll}
          disabled={criteria.length === 0}
        >
          <Icon icon="trash" />
          Clear
        </Button>
      </div>
    </div>
  );
}
